import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createBlock(_component_Datatable, {
    "table-data": _ctx.tableData,
    "table-header": _ctx.tableHeader,
    total: _ctx.localPagination.total,
    rowsPerPage: _ctx.rowsPerPage,
    page: _ctx.localPagination.page,
    loading: _ctx.loading,
    showSearch: _ctx.showSearch,
    tableFilter: _ctx.tableFilter,
    viewName: "formsActivity",
    onQueryUpdate: _ctx.syncQuery,
    "onUpdate:rowsPerPage": _ctx.updateRowsPerPage,
    "onUpdate:page": _ctx.updatePage,
    ref: "Datatable"
  }, {
    "cell-createdDate": _withCtx(({ row: form }) => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.format.DateTime(form.createdDate)), 1)
    ]),
    "cell-createdBy": _withCtx(({ row: form }) => [
      _createElementVNode("span", _hoisted_2, _toDisplayString(form.createdBy), 1)
    ]),
    "cell-descriptions": _withCtx(({ row: form }) => [
      _createElementVNode("span", {
        class: "text-truncate",
        title: _ctx.format.convertUTCToLocal(form.description)
      }, _toDisplayString(_ctx.format.convertUTCToLocal(form.description)), 9, _hoisted_3)
    ]),
    _: 1
  }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "tableFilter", "onQueryUpdate", "onUpdate:rowsPerPage", "onUpdate:page"]))
}